import { isArray } from 'util';
import { SubactivityBuilder } from './subactivity.builder';
import { ControlBuilder } from './control.builder';
import { ActivityControl } from '../activity-control';

export class ActivityControlBuilder {
  static fromJson(json) {
    return (json)
      ? new ActivityControl(
        json.hash,
        json.description,
        json.activityStartTxt,
        SubactivityBuilder.fromJson(json.subactivity),
        ControlBuilder.fromJson(json.control)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ActivityControlBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/activity-control.builder.ts